import React, { Component } from 'react'
import { observer } from 'mobx-react'
import withStyles from 'react-jss'
import classNames from 'classnames'

import { COURSE_LESSONS_NAV_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'

import CustomButton from '../custom-button/CustomButton'
import mobileLessonsNavigationStyles from './mobileLessonsNavigationStyles'

@observer
class MobileLessonsNavigation extends Component {
  render() {
    const {
      classes,
      courseViewsStore: {
        setPrevLesson,
        setNextLesson,
        viewConfig: { showPrevBtn, showNextBtn, lessonIsFinished, shouldCompleteQuiz },
      },
      noPaddings,
      toggleSideMobileMenu,
      rightSideBar,
      leftSideBar,
      bottomNavigationEnabled,
    } = this.props
    const isNavigationButtonDisabled = shouldCompleteQuiz && lessonIsFinished
    const lessonsNavigationClasses = classNames(
      COURSE_LESSONS_NAV_CLASS_NAMES.containerClassName,
      classes.mobileLessonsNavigation,
      noPaddings && classes.noPaddings
    )

    return (
      <div className={lessonsNavigationClasses}>
        {bottomNavigationEnabled && (
          <div className={classes.mobileLessonButtons}>
            <CustomButton
              onClick={setPrevLesson}
              hidden={!showPrevBtn}
              disabled={isNavigationButtonDisabled}
              className={classes.button}
            >
              <i className='fas fa-chevron-left' />
            </CustomButton>

            <CustomButton
              onClick={setNextLesson}
              hidden={!showNextBtn}
              disabled={isNavigationButtonDisabled}
              className={classes.button}
            >
              <i className='fas fa-chevron-right' />
            </CustomButton>
          </div>
        )}

        {(rightSideBar || leftSideBar) && (
          <CustomButton
            onClick={toggleSideMobileMenu}
            className={classes.outlineButton}
            hidden={!(rightSideBar || leftSideBar)}
            outline
          >
            <i className='fas fa-bars' />
            <span>{I18n.t('react.shared.course_program')}</span>
          </CustomButton>
        )}
      </div>
    )
  }
}

export default withStyles(mobileLessonsNavigationStyles)(MobileLessonsNavigation)
